import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
var Head = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-top:  ", ";\n  background-color: ", ";\n\n  @media print {\n    display: none;\n  }\n"])), function (props) {
  return props.liteMode ? 'unset' : '1rem';
}, function (props) {
  return props.theme.colors.light;
});
export default Head;